import { UseEmpathyAdapterOptions } from '@/adapters/adapter.configurator';
import { mapBlogPostHook } from '@/adapters/tuandco-blog-result.transformer';
import { TuandcoFacetMapper } from '@/adapters/tuandco-facet.mapper';
import { TuandcoResultMapper } from '@/adapters/tuandco-result.mapper';

export const ADAPTER_CONFIG: UseEmpathyAdapterOptions = {
  configureAdapter(builder) {
    builder
      .addMapper(TuandcoResultMapper, 'results')
      .addMapper(TuandcoFacetMapper, 'facets')
      .onResponseTransformed(mapBlogPostHook, 'search')
      .setFacetConfig({
        prefix: {
          facetName: 'priceSort'
        }
      }, 'price_facet')
      .withConfiguration({
        features: {
          search: {
            responsePaths: {
              results: location.href.includes('aprendeymejora') ? 'blog.docs' : 'content.docs',
              facets: location.href.includes('aprendeymejora') ? 'blog.facets' : 'content.facets'
            }
          }
        }
      });
  }
};
